__turbopack_context__.v({
  "mobileStoreBadgesWrapper": "fullFooter-module-scss-module__1QsWeq__mobileStoreBadgesWrapper",
  "primaryLinksWrapper": "fullFooter-module-scss-module__1QsWeq__primaryLinksWrapper",
  "socialMediaIcons": "fullFooter-module-scss-module__1QsWeq__socialMediaIcons",
});
